import { createFileRoute, redirect } from "@tanstack/react-router";
import { withQuery } from "@/lib/redirect-query";

// Legacy WordPress city path — permanently redirect to the /locations parent.
export const Route = createFileRoute("/location/milwaukee")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: withQuery("/locations/wisconsin/milwaukee/", location.searchStr), statusCode: 301 });
  },
});
